// extracted by mini-css-extract-plugin
export default {"Container":"user_Container__utLKt","SpinWrap":"user_SpinWrap__gVRWH","ActionWrap":"user_ActionWrap__Flybu","NewUserButton":"user_NewUserButton__PwE4k"};